import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { PromotionReplyApi } from 'api/ApiHelper';

export const useLikePromotionReplyMutation = (promotionId: number, replyId: string, options: UseMutationOptions) =>
  useMutation({
    mutationFn: () => PromotionReplyApi.likePromotionReply(promotionId, replyId),
    ...options,
  });
